// extracted by mini-css-extract-plugin
module.exports = {"valueSection__items":"benefits-section_valueSection__items__gwA4p","valueSection__item":"benefits-section_valueSection__item__7O1zJ"};